import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroRecipeBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import HeroImage from './HeroImage'

const copy = {
  overline: `Healthcare`,
  heading: `Use real-time data to deliver better outcomes across the care journey`,
  description: `Segment makes it easy to build a robust data foundation in a HIPAA compliant manner, so you can focus on personalized interactions with patients, members and clinicians.`,
}

const FORM_ID = `healthcare-demo-request`

const Hero = () => {
  return (
    <Wrapper>
      <StyledHeroRecipeBase variant="centered">
        <HeroRecipe.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Overline>{copy.overline}</CopyText.Overline>
            <CopyText.Heading tag="h1" variant="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pExtraLarge">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
          <HeroRecipeForm>
            <DemoForm
              isProgressive={true}
              customFormIdentifier={FORM_ID}
              customTrackingType={FORM_ID}
              successMessageAppearance="twilioLight"
            />
          </HeroRecipeForm>
        </HeroRecipe.Copy>
        <HeroRecipeContents>
          <HeroImage />
        </HeroRecipeContents>
      </StyledHeroRecipeBase>
    </Wrapper>
  )
}

const HeroRecipeContents = styled(HeroRecipe.Contents)`
  padding-top: 46px;
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding-top: 20px;
  }
`

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledHeroRecipeBase = styled(HeroRecipeBase)`
  ${HeroRecipe.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`sm`)} {
      padding-top: 80px;
    }
  }
`

const HeroRecipeForm = styled(HeroRecipe.Form)`
  padding-top: 48px;
  margin: 0 auto;
`

export default Hero
